module.exports = __webpack_public_path__ + "img/fuwu4.1a8d0b8e.png";